export const PANEL_MODE_CREATE = 'create'
export const PANEL_MODE_UPDATE = 'update'

export enum PANEL_MODE {
    CREATE= PANEL_MODE_CREATE,
    UPDATE = PANEL_MODE_UPDATE
}